import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"

import { RecipeProps } from "./Recipe"

export const { WithSuspense: SharedRecipe } = lazyloadHelper<RecipeProps>(
    () => import(/* webpackChunkName: "Recipe" */ "./Recipe") as any,
)
